import { render, staticRenderFns } from "./Pecuario.vue?vue&type=template&id=7935ca44&scoped=true"
import script from "./Pecuario.vue?vue&type=script&lang=js"
export * from "./Pecuario.vue?vue&type=script&lang=js"
import style0 from "./Pecuario.vue?vue&type=style&index=0&id=7935ca44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7935ca44",
  null
  
)

export default component.exports